// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import model_1 from '/data/landun/workspace/src/models/activityAbTest';
import model_2 from '/data/landun/workspace/src/models/activityCycle';
import model_3 from '/data/landun/workspace/src/models/activityManage';
import model_4 from '/data/landun/workspace/src/models/activityReport';
import model_5 from '/data/landun/workspace/src/models/activityWhatsApp';
import model_6 from '/data/landun/workspace/src/models/businessControlConfig';
import model_7 from '/data/landun/workspace/src/models/common';
import model_8 from '/data/landun/workspace/src/models/contactAttributes';
import model_9 from '/data/landun/workspace/src/models/contactManage';
import model_10 from '/data/landun/workspace/src/models/contactReport';
import model_11 from '/data/landun/workspace/src/models/contactSignUpForm';
import model_12 from '/data/landun/workspace/src/models/emailConfig';
import model_13 from '/data/landun/workspace/src/models/home';
import model_14 from '/data/landun/workspace/src/models/labelManage';
import model_15 from '/data/landun/workspace/src/models/newsletter';
import model_16 from '/data/landun/workspace/src/models/placeholderManage';
import model_17 from '/data/landun/workspace/src/models/pushNotification';
import model_18 from '/data/landun/workspace/src/models/segmentsManage';
import model_19 from '/data/landun/workspace/src/models/templateManage';
import model_20 from '/data/landun/workspace/src/models/testerManage';
import model_21 from '/data/landun/workspace/src/models/userJourney';

export const models = {
model_1: { namespace: 'activityAbTest', model: model_1 },
model_2: { namespace: 'activityCycle', model: model_2 },
model_3: { namespace: 'activityManage', model: model_3 },
model_4: { namespace: 'activityReport', model: model_4 },
model_5: { namespace: 'activityWhatsApp', model: model_5 },
model_6: { namespace: 'businessControlConfig', model: model_6 },
model_7: { namespace: 'common', model: model_7 },
model_8: { namespace: 'contactAttributes', model: model_8 },
model_9: { namespace: 'contactManage', model: model_9 },
model_10: { namespace: 'contactReport', model: model_10 },
model_11: { namespace: 'contactSignUpForm', model: model_11 },
model_12: { namespace: 'emailConfig', model: model_12 },
model_13: { namespace: 'home', model: model_13 },
model_14: { namespace: 'labelManage', model: model_14 },
model_15: { namespace: 'newsletter', model: model_15 },
model_16: { namespace: 'placeholderManage', model: model_16 },
model_17: { namespace: 'pushNotification', model: model_17 },
model_18: { namespace: 'segmentsManage', model: model_18 },
model_19: { namespace: 'templateManage', model: model_19 },
model_20: { namespace: 'testerManage', model: model_20 },
model_21: { namespace: 'userJourney', model: model_21 },
} as const
